var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M13.82 5.021 9.986.71C9.74.414 9.252.389 8.966.644c-.286.257-.315.745-.05 1.023l2.77 3.114H.823a.719.719 0 1 0 0 1.438h10.863l-2.77 3.114c-.266.278-.23.766.057 1.022.286.256.767.231 1.013-.063l3.833-4.313c.25-.348.23-.661 0-.958"
})));
export default SvgArrowRight;